import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { MastertablesService } from "../mastertables.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RoutingConstants } from "../../constants/routingConstants";
import { FilterConstants } from "src/app/constants/filterConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { CommonService } from "src/app/core/services/common.service";
import { FieldStructure } from "../models/field-structure-mastertables";

@Component({
  selector: "app-create-edit-mastertables",
  templateUrl: "./create-edit-mastertables.component.html",
  styleUrls: ["./create-edit-mastertables.component.sass"],
})
export class CreateEditMastertablesComponent implements OnInit {
  mastertable;
  operation: string;
  routing: any;
  mastertableId: string;
  fields: FieldStructure[] = [];
  type: any;
  formLoaded: boolean = false;
  types = FilterConstants.typesToNumber;
  rowid: string = "";
  data: any;
  file: any;
  fieldsID: any;
  indexID: number = -1;

  constructor(
    private mastertablesService: MastertablesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.type = this.activatedRoute.data["_value"]["type"];
    if (this.type == "S") {
      this.routing = RoutingConstants.masterTableRoutingS;
    } else if (this.type == "D") {
      this.routing = RoutingConstants.masterTableRoutingD;
    }
    this.initLoad();
  }

  initLoad() {
    this.fields = this.mastertablesService.getCurrentFieldsStructure();
    if (this.fields.length == 0) {
      this.goList();
    }
    if (this.activatedRoute.snapshot.params.mastertable) {
      this.mastertableId = this.activatedRoute.snapshot.params.mastertable;
    }
    if (
      this.operation === "edicion" &&
      this.activatedRoute.snapshot.params.id
    ) {
      this.rowid = this.activatedRoute.snapshot.params.id;
      this.mastertablesService
        .getDataOfMastertable(this.rowid, this.mastertableId)
        .subscribe(
          (data) => {
            this.data = data;
            this.fields.forEach((element) => {
              element.tipo = this.setTypeOfField(element);
            });

            this.initFormEdit(data);
          },
          (err) => {
            this.toastrAlertService.toastrFail(
              err.error.mensaje,
              this.routing.list
            );
          }
        );
    } else if (this.operation === "creacion") {
      this.fields.forEach((element) => {
        if (element.nombre === "ID") {
          this.fieldsID = element;
          this.indexID = this.fields.indexOf(element);
        }
      });

      this.initFormEmpty();
    }
  }

  initFormEmpty() {
    this.mastertable = new FormGroup({});
    this.fields.forEach((element) => {
      element.tipo = this.setTypeOfField(element);
      let valueDefault = this.setDefaultValue(element.nombre);
      if (element.nombre !== "ID") {
        if (element.nullable == 0) {
          this.mastertable.addControl(
            element.nombre,
            new FormControl(valueDefault, [
              Validators.maxLength(element.longitud),
              Validators.required,
            ])
          );
        } else {
          this.mastertable.addControl(
            element.nombre,
            new FormControl(
              valueDefault,
              Validators.maxLength(element.longitud)
            )
          );
        }
      }
    });

    this.formLoaded = true;
  }

  getBinario(nombre) {
    return this.data?.campos?.find((campo) => campo.nombre == nombre)?.binario;
  }

  initFormEdit(data) {
    this.mastertable = new FormGroup({});
    data.campos.forEach((element) => {
      let field = this.fields.find((e) => e.nombre == element.nombre);
      if (field.tipo.toString() == this.types.blob) {
        field.nullable = 1;
        if (element.binario != null) {
          this.file = this.commonService.b64toBlob(
            element.binario,
            "application/octet-binary"
          );
        }
      }
      let valueDefault = this.setDefaultValue(field.nombre);
      if (valueDefault !== "") element.valor = valueDefault;
      if (field && field.nullable == 0) {
        if (field.tipo.toString() == this.types.dateAux) {
          let date = this.getDate(element);
          this.mastertable.addControl(
            element.nombre,
            new FormControl(date, Validators.required)
          );
        } else {
          this.mastertable.addControl(
            element.nombre,
            new FormControl(element.valor, [
              Validators.maxLength(
                element.longitud != 0 ? element.longitud : 15
              ),
              Validators.required,
            ])
          );
        }
      } else {
        if (field && field.tipo.toString() == this.types.dateAux) {
          let date = this.getDate(element);
          this.mastertable.addControl(element.nombre, new FormControl(date));
        } else {
          this.mastertable.addControl(
            element.nombre,
            new FormControl(
              element.valor,
              Validators.maxLength(
                element.longitud != 0 ? element.longitud : 15
              )
            )
          );
        }
      }
    });
    this.formLoaded = true;
  }

  private getDate(element: any): string {
    let day: string, month: string, year: string;
    let date: string;
    if (element && element.valor && element.valor.includes("/")) {
      [day, month, year] = element?.valor?.split("/");
      date = `${year}-${month}-${day}`;
    } else if (element && element.valor && element.valor.includes("-")) {
      [day, month, year] = element?.valor?.split("-");
      date = `${year}-${month}-${day}`;
    } else {
      date = "";
    }

    return date;
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.mastertable.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else if (this.operation === "edicion") {
      let data = this.formatToUpdate();
      this.mastertablesService
        .updateDataOfMastertable(data, this.mastertableId, this.file)
        .subscribe(
          (data) => {
            this.toastrAlertService.toastrSuccess(
              data.mensaje,
              this.routing.list
            );
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    } else if (this.operation === "creacion") {
      let data = this.formatToSave();

      this.mastertablesService
        .createDataOfMastertable(data, this.mastertableId, this.file)
        .subscribe(
          (data) => {
            this.toastrAlertService.toastrSuccess(
              data.mensaje,
              this.routing.list
            );
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  formatToSave() {
    let arrayFields = [];
    this.fields.forEach((element) => {
      let objectField = {
        binario: null,
        nombre: element.nombre,
        tipo: element.tipo,
        valor: this.mastertable.value[element.nombre]
          ? this.mastertable.value[element.nombre]
          : element.tipo == 2
          ? 0
          : "",
        longitud: element.nombre == "ID" ? 15 : element.longitud,
      };
      arrayFields.push(objectField);
    });
    let result = {
      campos: arrayFields,
      rowid: this.rowid,
      empty: false,
    };
    return result;
  }

  formatToUpdate() {
    this.data.campos.forEach((element) => {
      element.valor = this.mastertable.value[element.nombre];
      element.valor =
        element.valor || element.valor === 0 ? element.valor.toString() : "";
      element.binario = null;
    });

    return this.data;
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  handleFileInput(fileInput: any, fieldNombre) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      let name = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let blob = this.commonService.castToBlob(e.target.result);
        this.file = blob;
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  consultaValorDelCampo(nombreCampo) {
    if (this.mastertable != null && this.mastertable.value != null) {
      const fileName = this.mastertable.value[nombreCampo];
      if (fileName != null && fileName != "") {
        return fileName;
      }
    }
  }

  construyeNombreDeFicheroParaDescargar(field) {
    if (this.mastertableId == "AyudasGenerales") {
      const fileName = this.consultaValorDelCampo("AY_FICHERO");
      if (fileName != null && fileName != "") {
        return fileName;
      }
      if (this.mastertable != null && this.mastertable.value != null) {
        return this.mastertable.value[field.nombre];
      }
    }
    return "";
  }

  downloadFile(field) {
    const fileName = this.construyeNombreDeFicheroParaDescargar(field);
    const a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const url = window.URL.createObjectURL(this.file);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  public hideFields(fieldName: string): boolean {
    if (fieldName === "PR_MARCOLEGAL") {
      return false;
    } else {
      return true;
    }
  }

  private setDefaultValue(fieldName: string): string {
    let value = "";
    switch (fieldName) {
      case "PR_MARCOLEGAL":
        value = "N";
        break;

      default:
        break;
    }

    return value;
  }

  private setTypeOfField(field: FieldStructure): number {
    //Implementacion solo para la mastertabla de mensaje inicio
    let type = field.tipo;
    switch (field.nombre) {
      case "MI_TEXT":
        type = parseInt(FilterConstants.typesToNumber.textArea);
        break;

      default:
        break;
    }
    return type;
  }

  public getLabelName(name: string) {
    let label: string = name.substring(name.indexOf("_") + 1);
    return label;
  }
}
